import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import SizeConfiguration from '../views/SizeConfiguration.vue'
import RoutableOptionsSelector from '../components/options/RoutableOptionsSelector.vue'

declare global {
  interface Window { productCode: string }
}

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/',
    redirect: '/' + window.productCode + '/sizeConfiguration'
  },
  {
    path: '/:productCode/sizeConfiguration',
    name: 'Size & Configuration',
    component: SizeConfiguration,
    alias: '/:productCode'
  },
  {
    path: '/:productCode/:menuItemUrl/:categoryUrl?',
    name: 'RoutableOptions',
    component: RoutableOptionsSelector
  },
  {
    path: '/*',
    redirect: '/'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
